import { render, staticRenderFns } from "./GameForm.vue?vue&type=template&id=63f71a52"
import script from "./GameForm.vue?vue&type=script&lang=js"
export * from "./GameForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports